import AICall from './AICall';

const AICallConfig = {
	settings: {},
	routes: [
		{
			path: '/ai/calls',
			component: AICall
		}
	]
};

export default AICallConfig;
